import React from 'react';
import { useTime } from 'react-timer-hook';

function MiTime() {
    const {
        seconds,
        minutes,
        hours,
        ampm
    } = useTime({ format: '24-hour' });
  
    var timer = 0;
timer = setInterval(function(){ 
	//var currentdate = new Date();  
    if(minutes % 5 === 0 && seconds === 2 ) {
        window.location.reload(false);

	}/*
	if(currentdate.getMinutes() % 1 == 0 && currentdate.getSeconds() == 30) {
		console.log("Alarm");
        setAllAlertas([[]])
	}*/
}, 1000);
//to stop: clearInterval(timer)

    return (
        <>
            
            {minutes%5 >= 2 ? <span> Actualizado hace {minutes%5} minutos, </span>:<span style={{color:'red'}}> Actualizado, </span>}
            <span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span><span>{ampm}</span>
        </>
    );
}

export default MiTime